import { jsx, jsxs } from 'react/jsx-runtime';
import { useId, useContext } from 'react';
import classNames from 'classnames';
import { InputContext } from '../../Input.Context/Input.Context.es.js';

const InputInlineAffix = ({ variant = 'prefix', intent = 'default', labelProps, className, children, ...rest })=>{
    const ariaId = useId();
    const { inputLabelId, labelSuffix } = useContext(InputContext);
    const affixCss = classNames('input-affix', `intent-${intent}`, variant, className);
    if (intent === 'label') {
        return jsx("div", {
            className: affixCss,
            ...rest,
            children: jsxs("label", {
                "data-testid": "label",
                id: inputLabelId,
                ...labelProps,
                children: [
                    children,
                    labelSuffix && jsx("span", {
                        className: "label-suffix",
                        "data-testid": "label-suffix",
                        children: labelSuffix
                    })
                ]
            })
        });
    }
    return jsxs("div", {
        "aria-describedby": ariaId,
        className: affixCss,
        ...rest,
        children: [
            jsx("span", {
                children: children
            }),
            jsx("span", {
                className: "sr-only",
                id: ariaId,
                children: children
            })
        ]
    });
};
InputInlineAffix.displayName = 'Input.Inline.Affix';

export { InputInlineAffix };
//# sourceMappingURL=Input.Inline.Affix.es.js.map
